<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80">
    <circle
      cx="40"
      cy="40"
      r="39.75"
      fill="#fff"
      stroke="#BABABF"
      strokeWidth="0.5"/>
    <path
      stroke="#585B65"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M56.37 28.537a10.188 10.188 0 00-11.102-2.21 10.186 10.186 0 00-3.305 2.21L40 30.5l-1.963-1.963A10.188 10.188 0 0023.63 42.944l1.963 1.963L40 59.315l14.407-14.408 1.964-1.962a10.187 10.187 0 000-14.408v0z"/>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M23.333 21.852L58.52 60.74"/>
    <path
      stroke="#585B65"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M19.63 21.852L54.815 60.74"/>
  </svg>
</template>
